module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-17.29c0f9ab.png";